var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("订单信息")))])]), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单号")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.orderNo || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单来源")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.appName || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("创建时间")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.createAt || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("牌照所属")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.licenseCustomerName || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品代码")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.code || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.customerInsuranceName ? _vm.dataFrom.customerInsuranceName.name : "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保单位")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.unitName || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("机构全称")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.agencyName || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("用户名")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.userName || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("手机号")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.mobile || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单归属")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.customerName || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("购买数量")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.servings || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品价格")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.price || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付金额")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.paymentAmount || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _vm.dataFrom.discountPremium && Object.keys(_vm.dataFrom.discountPremium).length ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.dataFrom.discountPremium.discountMode === "ratio" ? _vm.$t("折扣比例") : _vm.$t("折扣金额")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.getValue(_vm.dataFrom.discountPremium)) + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("合计金额")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.totalFee || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付状态")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.dataFrom.payStatusName) || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付时间")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.dataFrom.paymentAt || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付方式")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.dataFrom.payTypeName) || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单状态")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.dataFrom.payStatusName))), _vm.dataFrom.payStatus == 3 || _vm.dataFrom.payStatus == 2 ? _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.detailedFun
    }
  }, [_vm._v(_vm._s(_vm.$t("退款明细")))]) : _vm._e()], 1), _c("div", {
    staticClass: "right"
  })])])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单类型")
    }
  }, [_c("div", {
    staticClass: "contBox2"
  }, [_c("div", {
    staticClass: "cont"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.dataFrom.typeName) || "-") + " ")]), _c("div", {
    staticClass: "right"
  })])])], 1)], 1)], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品信息")))])]), _c("a-table", {
    staticClass: "marginT20",
    staticStyle: {
      width: "80%",
      margin: "0 auto"
    },
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: false,
      rowKey: "code"
    },
    scopedSlots: _vm._u([{
      key: "productType",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.refundShow ? _c("refund-model", {
    ref: "refundFrom",
    on: {
      cancel: function ($event) {
        _vm.refundShow = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };